import React, { useEffect, useState } from "react";
import Main_Page from "../Main_Page";
import {
  Page,
  TextContainer,
  Banner,
  Card,
  Frame,
  Stack,
  Icon,
  TextStyle,
  ThemeProvider,
  Button,
  Spinner,
  Badge,
} from "@shopify/polaris";
import { NotificationMajor } from "@shopify/polaris-icons";
import logo from "../Images/dashboard.png";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../footer";
import Video from "./video";

import * as authService from "../../services/authService";
import AcoountActivation from "./acoountActivation";
import AccountStatistics from "./accountStatistics";
import Loader from "../../Loader";
export const STATUS_CHANGE = "STATUS_CHANGE";

export default function Index() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [loadingPlan, setLoadingPlan] = useState(false);
  const [basicMsgOldStore, setBasicMsgOldStore] = useState(false);
  const [loadingFlagAdvance, setLoadingFlagAdvance] = useState(false);
  const status_change = useSelector((state) => state.allReducer.status_change);

  function statusChanged(status) {
    setLoading(true);
    authService
      .statusChange(status)
      .then((response) => {
        dispatch({
          type: STATUS_CHANGE,
          data: { ...response, loading: false },
        });
        setLoading(false);

        // if (response && response.data && response.data.data) {
        //   setStatus(response.data.data.status);
        // }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }

  function getPlanDetails() {
    setLoadingPlan(true);
    authService
      .planDetail()
      .then((res) => {
        console.log("res", res);
        if (res && res.data && res.data.data && res.data.data.plan == "basic") {
          if (res.data.data.redirectUrl && res.data.data.redirectUrl != "") {
            window.parent.location.replace(res.data.data.redirectUrl);
          } else {
            setLoadingPlan(false);
            setBasicMsgOldStore(true);
          }
        } else {
          setLoadingPlan(false);
        }
      })
      .catch((err) => {
        setLoadingPlan(false);
        console.log(err);
      });
  }

  useEffect(() => {
    getPlanDetails();
  }, []);

  const buyNowHandle = () => {
    setLoadingFlagAdvance(true);
    authService
      .premiumPlan()
      .then((response) => {
        if (response && response.status === 200) {
          window.parent.location.replace(response.data.data.redirect_url);
        }
      })
      .catch((error) => {
        setLoadingFlagAdvance(false);

        console.log(error);
      });
  };

  return (
    <Frame>
      <Main_Page />
      {status_change && (status_change.loading || loadingPlan) && <Loader />}
      <Page>
        <div style={{ display: "flex", margin: "50px 10px 0px 10px" }}>
          <div>
            <TextContainer>
              <div style={{ fontSize: "2.2rem", fontWeight: 495 }}>
                Better Account Signup {"  "}
                {status_change.status ? (
                  <Badge status="success">Active</Badge>
                ) : (
                  <Badge status="critical">Not Active</Badge>
                )}
              </div>
              {/* <p
                style={{
                  marginTop: "1.6rem",
                  color: "#637381",
                  fontSize: "1.85rem",
                  lineHeight: "1.6em",
                }}
              >
                Increase account activations with a customizable area that
                invites users to activate their account from the order
                confirmation page.
              </p> */}
            </TextContainer>
          </div>
          {/* <div>
                        <img style={{ height: "150px" }} src={logo}></img>
                    </div> */}
        </div>
        <br />
        <br />
        {basicMsgOldStore && <Banner
          title="Free Plans ending October 31st"
          action={{
            content: `${
              loadingFlagAdvance ? <Spinner size="small" /> : "Upgrade plan"
            }`,
            onClick: () => buyNowHandle(),
          }}
          status="critical"
        >
          <p>
            To continue using our app, all merchants must upgrade to our $10
            plan by the 31st October. Upgraded plans will be able to use all app features.
          </p>
        </Banner>}
        <br/>
        <Card>
          <Card.Section>
            <Stack alignment="center">
              <Icon source={NotificationMajor} />
              <Stack.Item fill>
                This app is currently{" "}
                {!loading ? (
                  status_change && !status_change.loading ? (
                    status_change.status ? (
                      <TextStyle variation="strong">enabled.</TextStyle>
                    ) : (
                      <TextStyle variation="strong">disabled.</TextStyle>
                    )
                  ) : (
                    <Spinner size="small" color="inkLightest" />
                  )
                ) : (
                  <Spinner size="small" color="inkLightest" />
                )}
              </Stack.Item>

              <Stack.Item>
                <ThemeProvider theme={{ colors: { primary: "#3b5998" } }}>
                  {status_change && !status_change.loading ? (
                    !status_change.status ? (
                      <Button
                        primary
                        monochrome={!loading}
                        loading={loading}
                        onClick={() => {
                          statusChanged("disabled");
                        }}
                      >
                        Enable
                      </Button>
                    ) : (
                      <Button
                        monochrome={!loading}
                        loading={loading}
                        onClick={() => {
                          statusChanged("enabled");
                        }}
                      >
                        Disable
                      </Button>
                    )
                  ) : (
                    <Spinner size="small" color="inkLightest" />
                  )}
                </ThemeProvider>
              </Stack.Item>
            </Stack>
          </Card.Section>
        </Card>
        <AcoountActivation />
        {/* <AccountStatistics /> */}
        <br />
        {/* <Video /> */}
        <Footer />
      </Page>
    </Frame>
  );
}
